/* eslint-disable react/prop-types */
import Button from '@s-ui/react-atom-button'
import TrackingWithEventTrackHoc from '@adv-mt/mt-tracking-with-event-track-hoc'

const CARFAX_EVENT_NAME = 'Carfax Product Clicked'

// TO DO: this component is no longer an experiment, it's being redesigned.
const Products = () => {
  const CarfaxButtonWithEventTrack = TrackingWithEventTrackHoc(Button, CARFAX_EVENT_NAME)

  return (
    <div>
      <h2 className="mt-experimentProduct-mainTitle">Otros servicios</h2>
      <p className="mt-experimentProduct-mainText">
        Descubre otros servicios que te pueden interesar si estás vendiendo tu coche
      </p>
      <div className="mt-experimentProduct">
        <div className="mt-experimentProduct-wrap">
          <h2 className="mt-experimentProduct-title">Añade un certificado a tu anuncio</h2>
          <p className="mt-experimentProduct-text">
            Proporciona a tus compradores confianza y transparencia con el informe de <strong>CARFAX</strong>. <br />
            Certifica el kilometraje, inspecciones, propietarios, y un historial completo de tu vehículo.
          </p>
        </div>
        <div>
          <CarfaxButtonWithEventTrack
            target="_blank"
            link
            href="https://www.carfax.es/partner-coches?utm_source=coches.net&utm_campaign=classifieds_integrations&utm_content=website_button&ct_st=dealer&ct_pm=model_1&ct_ts=consumer"
            type="primary"
          >
            Ver más
          </CarfaxButtonWithEventTrack>
        </div>
      </div>
    </div>
  )
}

export default Products
